export const setItemWithExpiry = (key: string, data: string, expiry: Date): void => {
  // setting as 2 separate keys so that modifying the existing data is not necessary.
  // This way `data` can literally be anything.
  localStorage.setItem(key, data)
  localStorage.setItem(`${key}-expiry`, expiry.toISOString())
}

export const getItemWithExpiry = (key: string): string | null => {
  const data = localStorage.getItem(key)
  const expiry = localStorage.getItem(`${key}-expiry`)

  if (!expiry) {
    return data
  }

  if (new Date(expiry) <= new Date()) {
    localStorage.removeItem(key)
    return null
  }

  return data
}
